import * as Validator from 'validatorjs';

class ValidatorController {

    constructor() {
        Validator.useLang('ja');

        this.about_customer();
        this.name();
        this.kana();
        this.email();
        this.emailConfirm();
        this.tel();
        this.dealer();
        this.vendor();
        this.staff();
        this.contact_detail();
        // this.calender();
        this.reserve_date();
    };

    name () {
        const elemName = 'name';
        const event = 'input';
        // バリデーションルール
        const rules = {
            name: ['required', 'max:100', 'regex:/^[^\\s]+\\s+[^\\s]+$/'],
        }
        const message = {
            required: 'お名前は必須です',
            regex: '姓名の間にスペースを入れてください',
            max: {
                string: ':max文字以内でご入力ください'
            }
        };
        const param = {
            elemName, event, rules, message,
        };
        this.setValidator(param);
    };

    kana() {
        const elemName = 'kana';
        const event = 'input';
        // バリデーションルール
        const rules = {
            kana: ['required', 'regex:/^[ぁ-んァ-ンー]+\\s+[ぁ-んァ-ンー]+$/', 'max:100'],
        }
        const message = {
            required: 'フリガナは必須です',
            regex: 'カタカナで姓名の間にスペースを入れてください',
            max: {
                string: ':max文字以内でご入力ください'
            }
        };
        const param = { elemName, event, rules, message}
        this.setValidator(param);

    }
    email() {
        const elemName = 'email';
        const event = 'input';
        // バリデーションルール
        const rules = {
            email: 'required|email',
        }
        const message = {
            required: 'メールアドレスは必須です',
            email: 'メールアドレスは、有効なメールアドレス形式で指定してください。',
        };
        const param = { elemName, event, rules, message}
        this.setValidator(param);
    }

    about_customer() {
        const elemName = 'about_customer';
        const event = 'change';
        // バリデーションルール
        const rules = {
            about_customer: 'required',
        }
        const message = {
            required: 'お客様については必須です',
        };
        const param = { elemName, event, rules, message}
        this.setValidator(param);
    }

    tel() {
        const elemName = 'tel';
        const event = 'input';
        // バリデーションルール
        const rules = {
            tel: 'required|regex:/^0\\d{9,10}$/',
        }
        const message = {
            required: 'お電話番号は必須です',
            regex: 'お電話番号の書式が正しくありません。',
        };
        const param = { elemName, event, rules, message}
        this.setValidator(param);
    }

    dealer() {
        const dealerElem = document.querySelector('input[name="dealer"]');
        dealerElem.addEventListener('change', e => {
            const vendorElem = document.querySelector('input[name="vendor"]');
            const staffElem = document.querySelector('input[name="staff"]');
            const data = {
                dealer: e.target.value,
                vendor: vendorElem.value,
                staff: staffElem.value,
            };
            const rules = {
                dealer: ['required'],
                vendor: [{ required_if: ['dealer', '1']}],
                staff: [{ required_if: ['dealer', '1']}],
            }
            const messages = {
                required: ':attributeについてご入力ください',
                required_if: ':attributeをご入力ください',
            }
            const validator = new Validator(data, rules, messages);
            validator.setAttributeNames({
                dealer: '仲介業者様',
                vendor: '業者様名',
                staff: 'ご担当者様',
            })
            validator.fails(() => {
                // console.log('x', validator.errors);
                const vendorParent = vendorElem.parentNode;
                const staffParent = staffElem.parentNode;
                // エラーメッセージ用のdivを作成
                const vendorErrorDiv = document.createElement('div');
                const staffErrorDiv = document.createElement('div');
                vendorErrorDiv.className = 'contact-content__error-text';  // 任意のクラス名を付与できます
                staffErrorDiv.className = 'contact-content__error-text';  // 任意のクラス名を付与できます
                vendorErrorDiv.textContent = validator.errors.first('vendor');
                staffErrorDiv.textContent = validator.errors.first('staff');

                // 既にエラーメッセージが存在するか確認
                const existingVendorErrorDiv = vendorParent.parentNode.querySelector('.contact-content__error-text');
                const existingStaffErrorDiv = staffParent.parentNode.querySelector('.contact-content__error-text');
                if (! existingVendorErrorDiv) {
                    vendorParent.parentNode.insertBefore(vendorErrorDiv, vendorParent.nextSibling);
                    vendorParent.classList.add('is-error');
                }
                if (! existingStaffErrorDiv) {
                    staffParent.parentNode.insertBefore(staffErrorDiv, staffParent.nextSibling);
                    staffParent.classList.add('is-error');
                }
            });
        });
        const radioNo = document.querySelectorAll('input[name="dealer"]')[1];
        radioNo.addEventListener('change', e => {
            // 既にエラーメッセージが存在するか確認
            let elems = radioNo.parentNode.parentNode.parentNode.querySelectorAll('.contact-content__error-text');
            // console.log(elems);
            elems.forEach(e => e.remove());
            document.querySelector('input[name="vendor"]').parentElement.classList.remove('is-error');
            document.querySelector('input[name="staff"]').parentElement.classList.remove('is-error');
        })
    }

    vendor() {
        const elemName = 'vendor';
        const event = 'input';
        // バリデーションルール
        const rules = {
            vendor: 'required|max:100',
        }
        const message = {
            required: '業者様名と担当者様名をご入力ください',
            max: 'お電話番号の書式が正しくありません。',
        };
        const param = { elemName, event, rules, message}
        this.setValidator(param);
    }

    staff() {
        const elemName = 'staff';
        const event = 'input';
        // バリデーションルール
        const rules = {
            staff: 'required|max:100',
        }
        const message = {
            required: '業者様名と担当者様名をご入力ください',
            max: 'お電話番号の書式が正しくありません。',
        };
        const param = { elemName, event, rules, message}
        this.setValidator(param);
    }

    calender() {
        let times = document.querySelectorAll('input[name="reserve_time[]"]');
        times.forEach(elem => {
            elem.addEventListener('click', e => {
                let dates = document.querySelectorAll('input[name="reserve_date[]"]');
                times = document.querySelectorAll('input[name="reserve_time[]"]');
                let calender = [];
                for (let i = 0; i < 3; i++) {
                    calender[i] = dates[i].value + ' ' + times[i].value;
                    calender[i] = calender[i].replace('〜', '');
                }
                let data = {
                    time1: times[0].value,
                    time2: times[1].value,
                    time3: times[2].value,
                    reserve_date1: calender[0],
                    reserve_date2: calender[1],
                    reserve_date3: calender[2],
                }
                const today = new Date();
                const yyyy = today.getFullYear();
                const mm = String(today.getMonth() + 1).padStart(2, '0');  // 月は0から始まるため1を足す
                const dd = String(today.getDate()).padStart(2, '0');
                const formattedDate = `${yyyy}/${mm}/${dd}` + ' ' + '00:00';
                data.today = formattedDate;
                let rules = {
                    time1: ['required'],
                    time2: ['required'],
                    time3: ['required'],
                    reserve_date1: ['required', 'date', 'after:today'],
                    reserve_date2: ['required', 'date', 'after:today', { different: ['reserve_date1']}],
                    reserve_date3: ['required', 'date', 'after:today', { different: ['reserve_date1']}, { different: ['reserve_date2']}],
                }
                const validator = new Validator(data, rules);
                validator.fails(() => {
                    // console.log(validator.input, validator.errors);

                    for (let i = 1; i < 4; i++) {
                        if (validator.errors.has(`time${i}`)) {
                            const input = document.querySelector(`#js-timepicker${i}`);
                            const textBoxes = input.parentNode.parentNode.querySelectorAll('.contact-content__input ');
                            textBoxes.forEach(e => {
                                e.classList.add('is-error');
                            })
                        }
                        if (validator.errors.has(`reserve_date${i}`)) {
                            const input = document.querySelector(`#js-datepicker${i}`);
                            const textBoxes = input.parentNode.parentNode.querySelectorAll('.contact-content__input');
                            textBoxes.forEach(e => {
                                e.classList.add('is-error');
                            })
                        }
                    }
                })
            });

        })
    }

    reserve_date() {
        let dates = document.querySelectorAll('input[name="reserve_date[]"]');
        dates.forEach(elem => {
            elem.addEventListener('click', e => {
                elem.parentElement.classList.remove('is-error');
                elem.parentElement.parentElement.parentElement.querySelector('.contact-content__error-text').remove();
            });
        })

        let times = document.querySelectorAll('input[name="reserve_time[]"]');
        times.forEach(elem => {
            elem.addEventListener('click', e => {
                elem.parentElement.classList.remove('is-error');
                elem.parentElement.parentElement.parentElement.querySelector('.contact-content__error-text').remove();
            });
        })
    }

    contact_detail() {
        const elemName = 'contact_detail';
        const elemType = 'textarea';
        const event = 'input';
        // バリデーションルール
        const rules = {
            contact_detail: ['required', 'max:1000'],
        }
        const message = {
            required: 'お問い合わせ内容をご入力ください',
            max: 'お問い合わせ内容は:max文字以内でご入力ください'
        };
        const param = { elemName, elemType, event, rules, message}
        this.setValidator(param);
    }

    emailConfirm() {
        const elemName = 'email_confirm';

        this.emailValidator(elemName);
    }

    emailValidator(elemName, emailElem, message) {
        // 検証するデータ
        const inputElement = document.querySelector(`input[name=${elemName}]`);

        inputElement.addEventListener('input', (e) => {
            const emailElement = document.querySelector('input[name="email"]');

            const inputValue = e.target.value;
            const parentElem = inputElement.parentNode;
            // input要素の2階層上の要素を参照
            const twoLevelsUp = e.target.parentNode.parentNode;
            const data = {
                email: emailElement.value,
                email_confirm: e.target.value,
            };
            // バリデーションルール
            const rules = {
                email: ['required',`email` ],
                email_confirm: ['same:email'],
            }
            const message = {
                required: 'メールアドレスは必須です',
                regex: 'メールアドレスをご確認ください',
                same: 'メールアドレスと同じ内容を入力して下さい'
            };
            const validator = new Validator(data, rules, message);
            const params = {
                elemName,
                inputValue,
                parentElem,
                twoLevelsUp,
                validator,
            }
            this.setMessage(params);
        });
    }

    setValidator(param) {
        // 検証するデータ
        const {
            elemName,
            elemType = 'input',
            event,
            rules,
            message
        } = param;
        const inputElement = document.querySelector(`${elemType}[name=${elemName}]`);
        if (! inputElement) return;

        inputElement.addEventListener(event, (e) => {
            const inputValue = e.target.value;
            const parentElem = inputElement.parentNode;
            // input要素の2階層上の要素を参照
            const twoLevelsUp = e.target.parentNode.parentNode;

            const validator = new Validator({[elemName]:inputValue}, rules, message);
            const params = {
                elemName,
                inputValue,
                parentElem,
                twoLevelsUp,
                validator,
            }
            this.setMessage(params);
        });
    }

    setMessage(params) {
        const {
            elemName,
            inputValue,
            parentElem,
            twoLevelsUp,
            validator,
        } = params;

        validator.fails(() => {
            // console.log(inputValue, '×', validator.errors.get('name'), validator);
            parentElem.classList.add('is-error');

            const errorMessages = validator.errors.get(elemName);

            // エラーメッセージ用のdivを作成
            const errorDiv = document.createElement('div');
            errorDiv.className = 'contact-content__error-text';  // 任意のクラス名を付与できます
            // errorDiv.textContent = divErrorMessage;
            errorDiv.textContent = errorMessages;

            // 既にエラーメッセージが存在するか確認
            const existingErrorDiv = twoLevelsUp.parentNode.querySelector('.contact-content__error-text');
            // エラーメッセージを2階層上の要素の後ろに挿入
            if(!existingErrorDiv) {
                twoLevelsUp.parentNode.insertBefore(errorDiv, twoLevelsUp.nextSibling);
            } else {
                existingErrorDiv.textContent = errorMessages;
            }
        });

        validator.passes(() => {
            // console.log(inputValue, '◎', validator);
            parentElem.classList.remove('is-error');
            const errorDiv = twoLevelsUp.parentNode.querySelector('.contact-content__error-text');
            if (errorDiv) {
                errorDiv.remove();  // エラーメッセージを削除する
            }
        });
    }
}

export default ValidatorController;


